/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_DescInputs */

const vi_camera_attach_desc = /** @type {(inputs: Camera_Attach_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera đang ở vùng khác sẽ được chuyển sang vùng này.`)
};

/**

* @param {Camera_Attach_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_desc = /** @type {((inputs?: Camera_Attach_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_desc(inputs)
});